<div id="editenduser" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper page-title-wrapper-margin">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <div class="container">
        <div class="row" [formGroup]="userFormGroup">
          <div class="userinfo col-md-6">
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantNameValidate" formControlName="out_company_name"
                placeholder="Tenant Name" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="tenantIdValidate" formControlName="out_tenant_id" placeholder="Tenant ID" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantDescriptionValidate" formControlName="out_tenant_desc"
                placeholder="Tenant Description" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantFirstNameValidate" formControlName="out_first_name"
                placeholder="First Name" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantLastNameValidate" formControlName="out_last_name" placeholder="Last Name"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantEmailValidate" formControlName="out_email" placeholder="EMAIL (Please Use A Current Valid Address)" required>
            </mat-form-field>

            <mat-form-field [floatLabel]="'always'" hidden>
              <input matInput formControlName="out_customer_id">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" hidden>
              <input matInput formControlName="out_country">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" hidden>
              <input matInput formControlName="out_culture">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'" hidden>
              <input matInput formControlName="out_digital_wallet_id">
            </mat-form-field>
          </div>

          <div class="userinfo col-md-6">
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine1" class="editTenantAddressLine1Validate" formControlName="out_address_1"
              (change)="omit_nonprintable_char($event)" placeholder="Address Line 1" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine2" class="editTenantAddressLine2Validate" formControlName="out_address_2"
              (change)="omit_nonprintable_char($event)" placeholder="Address Line 2">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput id= "addressLine3" class="editTenantAddressLine3Validate" formControlName="out_address_3"
              (change)="omit_nonprintable_char($event)" placeholder="Address Line 3">
            </mat-form-field>
            <!-- <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantCityValidate" formControlName="out_city" placeholder="City">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantStateValidate" formControlName="out_region" placeholder="State">
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantPostCodeValidate" formControlName="out_post_code" placeholder="Post Code">
          </mat-form-field> -->
          <!-- (keyup)="startFilterSub()" -->
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantCityValidate" (input)="onInputSub($event)"
                #myAutocompleteTriggerSub="matAutocompleteTrigger" [matAutocomplete]="autoSuburb"
                formControlName="out_city" placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)"
                (suburb)="startFilterSub($event)"
                 required>
              <mat-autocomplete #autoSuburb="matAutocomplete">
                <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option?.suburb"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- <mat-form-field [floatLabel]="'always'">
            <mat-select class="editTenantStateValidate" placeholder="State" formControlName="out_region" required>
              <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
            </mat-select>
          </mat-form-field> -->
            <ng-select class="customDropdwon editTenantStateValidate" [items]="stateList" bindValue="state"
              bindLabel="state" placeholder="State *" formControlName="out_region"></ng-select>
            <mat-form-field [floatLabel]="'always'">
              <!-- (keyup)="startFilterPostcode()" -->
              <input matInput class="editTenantPostCodeValidate" maxlength="4"
                #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
                (keypress)="isNumberKey($event)" formControlName="out_post_code" (postcode)="startFilterPostcode($event)"
                (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                placeholder="POST CODE" required>
              <mat-autocomplete #autoPostcode="matAutocomplete">
                <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option?.postcode"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="editTenantPhoneNumberValidate" formControlName="out_phone"
                placeholder="Phone Number" required>
            </mat-form-field>
          </div>

          <!-- <div class="userinfo col-md-6">
          <div class="usage-alert">Usage Alert Settings</div>
          <p>To receive data usage notifications via email when the tenant exceeds an usage limit please set a dollar
            value below.</p>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantMinThresholdValidate" formControlName="out_min_threshold"
              placeholder="Warning Alert Limit">
            <span matPrefix>$&nbsp;</span>
            <mat-icon matSuffix matTooltipClass="tooltip-red"
              matTooltip="A warning email will be sent when usage exceeds the entered dollar value">info</mat-icon>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantMaxThresholdValidate" formControlName="out_max_threshold"
              placeholder="Critical Alert Limit">
            <span matPrefix>$&nbsp;</span>
            <mat-icon matSuffix matTooltipClass="tooltip-red"
              matTooltip="A critical alert email will be sent when usage exceeds the entered dollar value">info
            </mat-icon>
          </mat-form-field>
          <mat-form-field [floatLabel]="'always'">
            <input matInput class="editTenantThresholdEmailValidate" formControlName="out_threshold_email"
              placeholder="Notification Email">
          </mat-form-field>
        </div>

        <div class="userinfo col-md-6" *ngIf="companyCode==='T01' || companyCode==='1'">
          <div class="payment-title">Payment Method</div>
          <div id="list-payment">
            <div class="noData-wrapper" *ngIf="!paymentList?.length">
              <div>
                <img src="../images/new_ui/no-wallet.png">
              </div>
              <div class="noData-label">Your digital wallet is empty.</div>
              <div class="button-center">
                <button id="addPaymentBtn" class="button button-red button-large"
                  (click)="navigateToDigitalWallet()">Create new</button>
              </div>
            </div>

            <ng-container *ngIf="paymentList?.length">
              <div class="row margin-top-30">
                <div class="col-sm">
                  <label class="po-label">Select a payment from your wallet</label><br />
                  <button class="button button-red button-mid reset-payment" (click)="resetPayment()">Reset Payment
                    Option</button>
                  <mat-form-field>
                    <mat-select [(value)]="selectedPayment" (change)="selectPaymentMethod();">
                      <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <ng-container *ngIf="hasEmptyFilterResult">
                <div class="noData-wrapper">
                  <div><img src="../images/new_ui/no-wallet.png"></div>
                  <div class="noData-label">Your digital wallet is empty.</div>
                  <div class="button-center">
                      <button class="button button-red button-large" (click)="navigateToDigitalWallet()">Create
                          now</button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div> -->

        </div>
        <!-- <div class="row">
        <div class="userinfo col-md-12" *ngIf="companyCode==='T01' || companyCode==='1'">
          <div class="payment-title">Payment Method</div>
          <div id="list-payment">
            <div class="noData-wrapper" *ngIf="!paymentList?.length">
              <div>
                <img src="../images/new_ui/no-wallet.png">
              </div>
              <div class="noData-label">Your digital wallet is empty.</div>
              <div class="button-center">
                <button id="addPaymentBtn" class="button button-red button-large"
                  (click)="navigateToDigitalWallet()">Create new</button>
              </div>
            </div>

            <ng-container *ngIf="paymentList?.length">
              <div class="row margin-top-30 dropdownBox">
                <div class="col-sm">
                  <label class="po-label">Select a payment from your wallet</label><br />
                  <button class="button button-red button-mid reset-payment" (click)="resetPayment()">Reset Payment
                    Option</button>
                  <mat-form-field>
                    <mat-select [(value)]="selectedPayment" (change)="selectPaymentMethod();">
                      <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <ng-container *ngIf="hasEmptyFilterResult">
                <div class="noData-wrapper">
                  <div><img src="../images/new_ui/no-wallet.png"></div>
                  <div class="noData-label">Your digital wallet is empty.</div>
                  <div class="button-center">
                      <button class="button button-red button-large" (click)="navigateToDigitalWallet()">Create
                          now</button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div> -->
        <div class="button-center">
          <button class="button button-red button-large" (click)="updateEndUser()">Save</button>
        </div>
        <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="984" (currentLoadingStatus)="onLoading($event)"></loading-screen>
      </div>
    </div>
  </div>
</div>